import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  Carousel,
  FixedSizeImageSource,
  StagedVersion,
  Video as CarouselVideo,
} from '../../types/carousel';
import { AppThunk } from '../store';
import getInitialMedia from '../../utils/getInitialMedia/getInitialMedia';

export interface Image {
  type: 'image';
  imageId: string;
  imageTitle?: string;
  source: FixedSizeImageSource;
  stagedVersions?: StagedVersion[];
}

type ImagePayloadAction = Pick<
  Image,
  'imageId' | 'imageTitle' | 'source' | 'stagedVersions'
>;

export interface Video {
  type: 'video';
  source: CarouselVideo;
}

export interface Pano {
  type: 'pano';
}

type State = Image | Video | Pano;

const mediaSlice = createSlice({
  initialState: { type: 'pano' } as State,
  name: 'media',
  reducers: {
    showImage: (state, action: PayloadAction<ImagePayloadAction>) => ({
      type: 'image',
      imageId: action.payload.imageId,
      imageTitle: action.payload.imageTitle,
      source: action.payload.source,
      stagedVersions: action.payload.stagedVersions,
    }),
    showVideo: (state, action: PayloadAction<CarouselVideo>) => ({
      type: 'video',
      source: action.payload,
    }),
    showPano: (state) => ({ type: 'pano' }),
  },
});

export const { showImage, showVideo, showPano } = mediaSlice.actions;

export const closeMedia =
  (carousel: Carousel): AppThunk =>
  (dispatch) => {
    const bestMedia = getInitialMedia(window.viewer?.getPano(), carousel);

    if (bestMedia?.mediaType === 'image') {
      return dispatch(
        showImage({
          imageId: bestMedia.image.imageId,
          imageTitle: bestMedia.image.title,
          source: bestMedia.image.image,
          stagedVersions: bestMedia.image.stagedVersions,
        })
      );
    }

    if (bestMedia?.mediaType === 'video') {
      return dispatch(showVideo(bestMedia.video));
    }

    dispatch(showPano());
  };

export default mediaSlice.reducer;
